import { Grid } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Circle } from "../../components/Circle";
import { MyButton } from "../../components/my-button/MyButton";
import MyContext from "../../contexts/MyContext";

export const FormWrapper = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);

  const onBack = () => {
    myContext.changeActiveSlide((myContext.activeSlide -= 1));
  };

  return (
    <Grid container style={{ padding: "1rem" }}>
    {props.number && (
      <Grid container item xs={12} sm={12} alignItems="center" wrap="nowrap" width={"100%"}>   
        <Circle>{props.number}</Circle>
        <h5 style={{ marginTop: "0", marginBottom: "0", marginLeft: "1rem" }}>{props.heading}</h5>
      </Grid>
      )}
      {!props.number && (
          <h5 style={{ marginTop: "0", marginBottom: "0"}}>{props.heading}</h5>
      )}
      <Grid container item xs={12} sm={12} justifyContent="center" width={"100%"}>
        {props.children}
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} width="100%">
        {(props.hasBackButton == null || props.hasBackButton !== false) && (
          <Grid item>
            <MyButton text={props.backButtonLabel ?? t("back")} color="primary" onClick={props.onBack ?? onBack} buttonVariant="outlined" />
          </Grid>
        )}
        {(props.hasContinueButton == null || props.hasContinueButton !== false) && (
          <Grid item>
            <MyButton text={props.continueButtonLabel ?? t("continue")} onClick={props.onContinue} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
